"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWebAPIAddress = exports.getAPILanguage = exports.getAPICountry = exports.getHostDomain = void 0;
var debug_1 = require("utils/debug");
var generateDomain_1 = require("utils/generateDomain");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var website_1 = require("utils/website");
require("isomorphic-fetch");
function checkStatus(response) {
    if (!response.ok) {
        var error = new Error(response.statusText);
        throw error;
    }
    return response;
}
function dealData(resp) {
    if (typeof resp.data.result !== "undefined" && typeof resp.data.jsonrpc !== "undefined") {
        return resp.data.result;
    }
    else {
        if (resp.status === 400) {
            return Promise.reject({
                status: resp.status,
                message: resp.data.message || "msg empty"
            });
        }
        return resp.data;
    }
}
var processUATAPIDomain = function (domain) {
    var countryCodeLower = getAPICountry().toLocaleLowerCase();
    return (website_1.isPC() || debug_1.isUAT()) && countryCodeLower
        ? domain.replace(countryCodeLower + ".65emall", "65emall")
        : domain;
};
function getHostDomain() {
    if (debug_1.isUAT()) {
        return "65emall.net";
    }
    else {
        return location.hostname;
    }
}
exports.getHostDomain = getHostDomain;
function getAPICountry() {
    return isomorphismConstant_1.default.countryCode;
}
exports.getAPICountry = getAPICountry;
function getAPILanguage() {
    return "en";
}
exports.getAPILanguage = getAPILanguage;
exports.generateWebAPIAddress = function generateWebAPIAddress(method) {
    var countryCodeLower = getAPICountry().toLocaleLowerCase();
    var clang = getAPILanguage();
    var domain = generateDomain_1.default(countryCodeLower + "-" + clang.toLowerCase() + "-" + (website_1.isPC() ? "web" : "mweb") + "-%SERVICE_TYPE%");
    var apiDomain = processUATAPIDomain(domain);
    var webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "api");
    webapiDomain = webapiDomain.replace("..", ".");
    if (method.includes("Cms")) {
        return "//" + webapiDomain + "/api/cms";
    }
    return "//" + webapiDomain + "/api";
};
function webapi(method, params) {
    return __awaiter(this, void 0, Promise, function () {
        var isProtobufMethod, url, headers, init;
        return __generator(this, function (_a) {
            isProtobufMethod = method.includes("/");
            url = "";
            url = "" + exports.generateWebAPIAddress(method) + ("/" + (isProtobufMethod ? method : method.replace(/\./g, "/")));
            headers = {
                "Content-Type": "application/json"
            };
            init = {
                method: "post",
                credentials: "include",
                headers: headers,
                body: JSON.stringify(params)
            };
            return [2, fetch(url, init)
                    .then(checkStatus)
                    .then(function (response) {
                    return response.json().then(function (json) { return ({ data: json, status: response.status }); });
                })
                    .then(dealData)];
        });
    });
}
exports.default = webapi;
